import moment from 'moment';

export const parseRun = (run, group) => {
    const blocks = [];
    const runBased = run.basedOn === 'RUN';

    // Not all dates present? => skip this run
    if (!run.arrivalAtFirstStop || !run.arrivalAtUnloadStop) {
        return blocks;
    }

    // The Run
    // departure -> arrival
    const runBlock = {
        id: run.runId + Math.random(),
        group,
        title: `${run.routeCode} - ${moment(run.runDate).format('DD/MM/YYYY')} - ${
            run.runSequence
        } (based on ${runBased ? 'run' : 'manifest'})`,
        start_time: moment.utc(run.arrivalAtFirstStop),
        end_time: moment.utc(run.arrivalAtUnloadStop),
        className: runBased ? 'run-based-run-block' : 'manifest-based-run-block',
        itemProps: {
            'data-run': JSON.stringify(run),
        },
    };
    blocks.push(runBlock);

    return blocks;
};
